import { useQuery } from '@tanstack/react-query';
import { getPricingInfo } from '@/services/pricing';

export const usePricingInfo = () => {
  return useQuery({
    queryKey: ['pricing-info'],
    queryFn: getPricingInfo,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
